import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { StockTransferHeader } from '../../_models/stockTransferHeader';
import * as _ from "lodash";
import { StockShipmentLine } from '../../_models/stockShipmentLine';
import { StockTransferLine } from '../../_models/stockTransferLine';
import { AlertService } from '../../_services/alert.service';
import { User } from "../../_models/user";

@Component({
  selector: 'app-processing-stock-transfers',
  templateUrl: './processing-stock-transfers.component.html',
  styleUrls: ['./processing-stock-transfers.component.scss'],
})
export class ProcessingStockTransfersComponent implements OnInit {
  progressWidth: any;
  order: StockTransferHeader = {};
  reviewOrder: StockTransferHeader = {};
  step: number = 1;
  shipmentId: any;
  showTransFer: boolean = false;
  showCourierTable: boolean = false;
  courier: any;
  orderStatusValue: string;
  courierId: number;
  awb_code: string;
  order_id: string;
  courierName: string;
  boxesCount: number = 0;
  productConfig: string;
  shippingMethod: string;
  deliveryInstructions: string;
  shipMethod: string;
  stockShipLines: Array<StockShipmentLine>;
  allShipLines: Array<StockShipmentLine>;
  stockShipLine: StockShipmentLine = {};
  configLineIdSeq: number = 1;
  stockTransferLine: StockTransferLine = {};
  stockTransferLines: StockTransferLine[] = [];
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  statusText10: string;
  statusText11: string;
  statusText12: string;
  statusText13: string;
  statusText14: string;
  statusText15: string;
  statusText16: string;
  statusText18: string;
  statusText19: string;
  errorMessage: string;
  errorMessage1: string;
  numberOfBoxesM: string;
  numberOfBoxes: string;
  package: any = [];
  boxes: any[] = [{ 'name': 'box' }];
  packagesList = [];
  request: any;
  rate: any;

  constructor(private alertService: AlertService, public st: StockTransferHeader, public user: User, private http: HttpClient, private g: Globals, private route: ActivatedRoute,
    private router: Router, private api: ApiIntegration) {
    this.g.page = "Processing Orders";
    this.progressWidth = "25%";
    this.api.getPackingTypesList("1").subscribe((data: any) => {
      this.package = data.getPackingTypesResponses;
      this.package.push({ packingType: 'Custom', height: '', width: '', lenght: '', weight: '' });
    }, err => {
      this.alertService.error('Error', err);
    });
    this.api.getStockTransferHeaderDetails(this.route.snapshot.params['id']).subscribe((data: StockTransferHeader) => {
      this.order = data;
      this.reviewOrder = (_.cloneDeep(this.order));
      this.reviewOrder.lines.forEach((sl: any) => {
        if (this.reviewOrder.shipLines) {
          sl.shipLines = this.reviewOrder.shipLines;
        }
      });
      this.order.lines.forEach((sl: any) => {
        if (!sl.shipLines || !sl.shiplines.length) {
          sl.shipLines = [{
            numberOfBoxes: null,
            quantityPerBox: null,
            productId: sl.productId,
            orderLineId: sl.orderLineId,
            boxHeight: null,
            boxWidth: null,
            boxLength: null,
            boxWeight: null,
            totalQuantity: null
          }];

        }
      });
      for (let shipLine of this.order.shipLines) {
        this.boxesCount = Number(this.boxesCount) + Number((shipLine || {}).numberOfBoxes);
      }

      if (this.order.orderStatus === 'READY_TO_SHIP' || this.order.orderStatus === 'AWAITING_CARRIER') {
        if (this.order.shippingOption === 'SHIFT') {
          this.step = 4;
          this.progressWidth = "100%";
        } else {
          this.step = 3;
          //this.progressWidth = "75%";
          this.shippingOptions();
        }
      }
    }, err => {
      this.alertService.error('Error', err);
    });

    /*this.api.getOrderInDetail(this.route.snapshot.params['id']).subscribe((data:StockTransferHeader)=> {
        this.reviewOrder = data;
        for (let o of this.reviewOrder.lines) {
            for (let shipLine of o.shipLines) {
                this.boxesCount = Number(this.boxesCount) + Number(shipLine.numberOfBoxes);
            }
        }
    },err=> {
     this.alertService.error('Error',err);
    });*/
  }

  openPackage() {
    this.packagesList = this.package;
  }
  selectShipmentConfigure() {
    this.statusText2 = "";
    if (this.order.productConfig == '' || this.order.productConfig === null || this.order.productConfig === undefined || this.order.productConfig === 'undefined') {
      this.statusText2 = 'Please select inventory configuration';
    }
    if (this.statusText2 != "") {
      return false;
    }
    this.step = 3;
    this.resetStatusText();
    this.progressWidth = "50%";
  }

  selectPackingConfigure() {
    this.statusText1 = "";
    if (this.order.shippingMethod == '' || this.order.shippingMethod === null || this.order.shippingMethod === undefined || this.order.shippingMethod === 'undefined') {
      this.statusText1 = 'Please select shipping method';
    }

    if (this.statusText1 != "") {
      return false;
    }
    this.step = 2;
    this.resetStatusText();
    this.progressWidth = "50%";
  }
  clearFields() {
    if (this.step === 1) {
      this.order.shippingMethod = "";
      this.statusText1 = "";
    } else if (this.step === 2) {
      this.order.productConfig = "";
      this.statusText2 = "";
    } else if (this.step === 3) {
      for (let o of this.order.lines) {
        o.qtyPerBoxTmp = null;
        o.numOfBoxesTmp = null;
        o.boxHeight = null;
        o.boxLength = null;
        o.boxWidth = null;
        o.boxWeight = null;
        o.packageType = undefined,
          o.shipLines = [{
            numberOfBoxes: null,
            quantityPerBox: null,
            productId: o.productId,
            orderLineId: o.orderLineId,
            packageType: undefined,
            boxHeight: null,
            boxWidth: null,
            boxLength: null,
            boxWeight: null,
            totalQuantity: null
          }];
      }
      //for (let o  of this.order.lines){
      //  this.removeShipmentLine(o, o.shipLines);
      //}
      this.statusText7 = "";
      this.statusText8 = "";
      this.statusText9 = "";
      this.statusText10 = "";
      this.statusText13 = "";
      this.statusText14 = "";
    } else if (this.step === 4) {
      this.order.shippingOption = null;
      this.statusText11 = "";
    } else if (this.step === 5) {
    }
  }
  backToShippingConfig() {
    this.step = 1;
    this.progressWidth = "33.2%";
  }
  shippingOptions() {
    //to Call Shiprocket API
    this.shipRocketForOrders();
    if (this.courier == '' || this.courier === null || this.courier === undefined || this.courier == 'undefined') {
      this.statusText14 = 'detail: System error. Please speak to Support team';
      return false;
    }
  }

  reviewAndConfirm() {
    this.boxesCount = 0;
    this.step = 4;
    this.resetStatusText();
    this.progressWidth = "100%";
  }

  backToAddPackage() {
    this.step = 2;
    this.progressWidth = "50%";
  }

  backToShipmentConfigure() {
    this.step = 2;
    this.progressWidth = "25%";
  }

  backToShipmentOptions() {
    if (this.order.shippingOption === "THIRD_PARTY") {
      this.step = 3;
      this.progressWidth = "75%";
    } else {
      this.router.navigate(['/admin/adminOrder']);
    }
  }

  ngOnInit() {
  }

  proceedShipRockForSE() {
    if (this.order.productConfig === 'SKU') {
      this.statusText13 = null;
      for (let sl of this.order.lines) {
        if (sl.shipLines === null || sl.shipLines === undefined) {
          this.statusText13 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
          return false;
        }
        let totalQuantity = 0;
        sl.shipLines.forEach((r) => {
          totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
        });
        if (sl.quantity != totalQuantity) {
          this.statusText14 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
          return false;
        }
      }
      this.allShipLines = [];
      for (let ol of this.order.lines) {
        for (let i = 0; i < ol.shipLines.length; i++) {
          if (!ol.shipLines[i].quantityPerBox || !ol.shipLines[i].numberOfBoxes) {
            ol.shipLines.splice(i, 1);
          }
        }
        this.allShipLines = ol.shipLines;
      }
    } else {
      this.statusText18 = "";
      this.statusText19 = "";
      this.order.lines[0].shipLines.forEach((r) => {
        if (!r.packingType) {
          this.statusText19 = 'Please select package type';
          return false;
        }
      });
      this.order.lines.forEach((s) => {
        if (!this.showIcon(s)) {
          this.statusText18 = 'Shipment quantity is not matched';
          return false;
        }
      });
      if (this.statusText19 !== "" || this.statusText18 !== "") {
        return false;
      }
      this.allShipLines = [];
      for (let ol of this.order.lines) {
        for (let i = 0; i < ol.shipLines.length; i++) {
          if (!ol.shipLines[i].quantityPerBox) {
            ol.shipLines[i].quantityPerBox = 0;
          }
        }
        this.allShipLines = ol.shipLines;
      }
    }
    this.orderStatusValue = "READY_TO_SHIP";
    /*  if (this.order.shippingOption  === 'SHIFT') {
          this.orderStatusValue = "GENERATE_LABEL";
      } else {
          this.orderStatusValue = "READY_TO_SHIP";
      }*/


    this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updatePackingConfigForStockTransferOrder', {
      "stockTransferHeaderId": this.order.stockTransferHeaderId,
      "orderStatus": this.orderStatusValue,
      "organizationId": 1,
      "productConfig": this.order.productConfig,
      "shipLines": this.allShipLines,
      "shippingMethod": this.order.shippingMethod
    },

      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success('ReadyToShip', 'Proceed Successfully');
          //   this.router.navigate(['/admin/viewOrders' , this.order.stockTransferHeaderId]);
          this.router.navigate(['/admin/adminStockTransfer']);

          /*if ( this.user.role == "ROLE_ADMIN" ) {
               this.router.navigate(['/admin/adminOrder']);
             } else {
               this.router.navigate(['/admin/workMenOrder']);
             } */
          /* if (this.order.shippingOption  === 'SHIFT') {
                 this.order.orderStatus = "GENERATE_LABEL";
             } else {
                 this.order.orderStatus = "READY_TO_SHIP";
             } */
        }
        else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },

        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });
  }

  submitOrderForShipment() {
    //this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    this.g.loaderDisplay = "display";
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    if (this.order.shippingOption !== "THIRD_PARTY") {
      this.http.post(environment.apiUrl + 'api/updateStockTransferH&L', {
        "stockTransferHeaderId": this.order.stockTransferHeaderId,
        "orderStatus": "GENERATE_LABEL",
        "organizationId": 1,
        "shippingOption": this.order.shippingOption
      },
        { headers: header1 }).subscribe(data => {
          this.g.loaderDisplay = "";
          if (data['code'] == 200) {
            this.alertService.success('OrderProcessing', 'Submitted Successfully');

            this.router.navigate(['/admin/stockTransferView', this.order.stockTransferHeaderId]);
          }
          else {
            this.alertService.error('Error', data['message']);
          }

        },

          (err: HttpErrorResponse) => {
            this.g.loaderDisplay = "";

          });
    } else {
      this.createThirdPartyShipment();
    }
  }

  addShipmentLine(o) {
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText15 = "";
    if (o.qtyPerBoxTmp === null || o.qtyPerBoxTmp === undefined) {
      this.statusText7 = 'Please enter quantity';
    }
    if (o.numOfBoxesTmp === null || o.numOfBoxesTmp === undefined) {
      this.statusText8 = 'Please enter no.of boxes';
    }
    if (o.packageType === null || o.packageType === undefined) {
      this.statusText15 = 'Please select package type';
    }
    if (o.boxHeight === null || o.boxHeight === undefined || o.boxLength === null || o.boxLength === undefined || o.boxWidth === null || o.boxWidth === undefined) {
      this.statusText9 = 'Please enter l*w*h';
    }
    if (o.boxWeight === null || o.boxWeight === undefined) {
      this.statusText10 = 'Please enter weight';
    }
    if (this.statusText7 != "" || this.statusText8 != "" || this.statusText15 != "" || this.statusText9 != "" || this.statusText10 != "") {
      return false;
    }
    if (o != null) {
      this.stockShipLines = (_.cloneDeep(o.shipLines));
      if (this.stockShipLines == null) {
        this.stockShipLines = [];
      }
      //Identify the StockLine
      //Add the StockShipmentLine to the StockLine
      //Clear the shipmentLine
      this.stockShipLine.numberOfBoxes = o.numOfBoxesTmp;
      this.stockShipLine.quantityPerBox = o.qtyPerBoxTmp;
      this.stockShipLine.productId = o.productId;
      this.stockShipLine.packageType = o.packageType;
      this.stockShipLine.orderLineId = o.orderLineId;
      this.stockShipLine.configLineId = this.configLineIdSeq;
      this.stockShipLine.boxHeight = o.boxHeight;
      this.stockShipLine.boxWidth = o.boxWidth;
      this.stockShipLine.boxLength = o.boxLength;
      this.stockShipLine.boxWeight = o.boxWeight;
      this.stockShipLine.totalQuantity = (o.numOfBoxesTmp * o.qtyPerBoxTmp);
      /*        this.stockShipLine.shipLines = [{
                        numberOfBoxes : null,
                        quantityPerBox : null,
                        productId : this.activeProduct.productId,
                        configLineId : this.configLineIdSeq,
                        boxHeight : null,
                        boxWidth : null,
                        boxLength : null,
                        boxWeight : null,
                        totalQuantity : null
                    }]; */
      this.stockShipLines.push(_.cloneDeep(this.stockShipLine));
      o.shipLines = _.cloneDeep(this.stockShipLines);
      let boxWg = 0;
      o.shipLines.forEach((ele) => {
        if (ele.quantityPerBox != null && ele.numberOfBoxes != null)
          boxWg = boxWg + (ele.quantityPerBox * ele.numberOfBoxes);
      });
      o.totalQuantity = boxWg;
      o.numOfBoxesTmp = null;
      o.qtyPerBoxTmp = null;
      o.boxHeight = null;
      o.packageType = undefined;
      o.boxWidth = null;
      o.boxLength = null;
      o.boxWeight = null;
      this.stockShipLine = {};
      this.configLineIdSeq = this.configLineIdSeq + 1;
    }
  }

  selectPackType() {
    this.order.lines.forEach((ol) => {
      for (let i = 0; i < ol.shipLines.length; i++) {
        ol.shipLines[i].packingType = this.order.lines[0].shipLines[i].packingType;
      }
    });
    this.order.lines.forEach((ol) => {
      ol.shipLines.forEach((sl) => {
        this.package.forEach((pack) => {
          if (sl.packingType == pack.packingType) {
            sl.boxHeight = pack.height;
            sl.boxWidth = pack.width;
            sl.boxLength = pack.length;
            sl.boxWeight = pack.weight;
          }
        });
      });
    });
    console.log(this.order.lines);
  }
  changeBox() {
    //this.boxes = [];
    if (this.numberOfBoxes != '') {
      this.order.lines.forEach((ol) => {
        //this.stockLines.numberOfBoxes = this.numberOfBoxesM;
        //debugger;
        ol.shipLines = [];
        for (let i = 1; i <= Number(this.numberOfBoxesM); i++) {

          ol.shipLines.push({
            numberOfBoxes: Number(this.numberOfBoxesM),
            quantityPerBox: 0,
            productId: ol.productId,
            configLineId: this.configLineIdSeq,
            boxHeight: null,
            boxWidth: null,
            boxLength: null,
            boxWeight: null,
            totalQuantity: null
          });
        }
      });
    }
    else {
      //this.boxes = [{'name':'box', 'value':0}];
    }
  }

  removeShipmentLine(r, s) {
    let index = r.shipLines.indexOf(s);
    r.shipLines.splice(index, 1);
    let boxWg = 0;
    r.shipLines.forEach((ele) => {
      if (ele.quantityPerBox != null && ele.numberOfBoxes != null)
        boxWg = boxWg + (ele.quantityPerBox * ele.numberOfBoxes);
    });
    r.totalQuantity = boxWg;
  }
  resetStatusText() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";
    this.statusText12 = "";
    this.statusText13 = "";
    this.statusText14 = "";
    this.statusText15 = "";
    this.statusText16 = "";
  }


  showAddShipRow(row) {
    let show = false;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
    });
    if (row.quantity == totalQuantity) {
      show = true;
    } else {
      this.statusText14 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
    }
    return show;
  }

  showAddShipmentBtn(row) {
    this.statusText14 = "";
    let show = true;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
    });
    if (row.quantity == totalQuantity) {
      show = false;
    }
    totalQuantity = totalQuantity + ((row.numOfBoxesTmp || 0) * (row.qtyPerBoxTmp || 0));
    if (row.quantity < totalQuantity) {
      this.statusText14 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
      show = false;
    }
    return show;
  }
  populateDimensions(row) {
    if (row.packageType) {
      let index = this.package.findIndex((d) => d.packingType === row.packageType);
      if (index > -1) {
        row.boxHeight = this.package[index].height;
        row.boxWidth = this.package[index].width;
        row.boxLength = this.package[index].length;
      }
    }
  }
  fieldsEntered(row) {
    let show = true;
    let textEntered = false;
    row.shipLines.forEach((r) => {
      if (r.quantityPerBox !== '' && r.quantityPerBox !== undefined && r.quantityPerBox) {
        textEntered = true;
      }
    });
    if (!textEntered) {
      show = false;
    }
    return show;
  }
  showIcon(row) {
    let show = true;
    let totalQuantity = 0;
    row.shipLines.forEach((r) => {
      totalQuantity = Number(totalQuantity) + ((Number(r.quantityPerBox) || 0));
    });

    if (Number(row.quantity) != totalQuantity) {
      show = false;
    }
    return show;
  }
  showShipIcon(row) {
    this.statusText14 = "";
    let show = false;
    let totalQuantity = 0;
    totalQuantity = totalQuantity + ((row.numOfBoxesTmp || 0) * (row.qtyPerBoxTmp || 0));
    row.shipLines.forEach((r) => {
      totalQuantity = totalQuantity + ((r.quantityPerBox || 0) * (r.numberOfBoxes || 0));
    });
    if (row.quantity == totalQuantity) {
      show = true;
    }
    if (row.quantity != totalQuantity) {
      this.statusText14 = 'Cannot proceed further as Shipping Quantity  is not equal to Total Quantity configured for packing';
      show = false;
    }
    return show;
  }



  shipRocketForOrders() {
    this.g.loaderDisplay = "display";

    //To Call ThirdParty Shipment
    // alert('test');
    var header2 = new HttpHeaders();
    header2 = header2.append('Content-Type', 'application/json');
    header2 = header2.append('Accept', 'application/json');
    header2 = header2.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    //alert('2:'+ sessionStorage.getItem('jwt'));
    //alert('3:'+ this.local.get('jwt'));

    this.http.post(environment.apiUrl + 'api/shipRockForStockTransferOrders?stockTransferHeaderId=' + this.order.stockTransferHeaderId, {
    },
      { headers: header2 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['status'] == "NEW" && data['code'] == "200") {
          //this.alertService.success('Shipment','Process updated successfully');
          this.showCourierTable = true;
          this.courier = data['serviceability'];
          this.shipmentId = data['shipment_id'];
          this.request.shipmentId = data['shipment_id'];
          //this.request = this.request.shipmentId;
        } else if (data['code'] == "404") {
          this.alertService.error('Error', data['message']);
          this.showCourierTable = false;
        } else {
          this.errorMessage = "System error. Please speak to Support team / Choose alternate Shipment method";
          this.showCourierTable = false;
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

          this.errorMessage = "detail: System error. Please speak to Support team";
          this.showCourierTable = false;
        });
  }


  changeCourier(id) {
    console.log(id);
    let index = this.courier.findIndex((d) => d.courier_company_id == Number(id));
    if (index > -1) {
      console.log(this.courier[index]);
      this.rate = this.courier[index].rate;
    }
  }
  createThirdPartyShipment() {
    //this.g.loaderDisplay = "display";
    var header2 = new HttpHeaders();
    header2 = header2.append('Content-Type', 'application/json');
    header2 = header2.append('Accept', 'application/json');
    header2 = header2.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/generateAWBForShip', {
      "courier_id": this.courierId,
      "shipment_id": this.shipmentId
    },
      { headers: header2 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['status_code'] == null) {
          var awbResponseObj = data['response'];
          var awbResponse = awbResponseObj['data'];
          this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
            "stockTransferHeaderId": this.order.stockTransferHeaderId,
            "orderStatus": "GENERATE_LABEL",
            "organizationId": 1,
            "awbNumber": awbResponse['awb_code'],
            "externalOrderId": awbResponse['order_id'],
            "externalShipmentId": awbResponse['shipment_id'],
            "shipmentPrice": this.rate
          },
            { headers: header2 }).subscribe(data => {
              this.g.loaderDisplay = "";
              if (data['code'] == 200) {
                this.alertService.success('Order', 'Pick Successfully');
                this.router.navigate(['/admin/viewOrders', this.order.stockTransferHeaderId]);
              }
              else {
                this.alertService.error('Error', data['message']);
              }

            },
              (err: HttpErrorResponse) => {
                this.g.loaderDisplay = "";
              });
        } else if (data['status_code'] == 350) {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.errorMessage1 = "System error. Please speak to Support team";
        });
  }
}
